<template>
  <div>
    <Row justify="center" type="flex" style="background: #ffffff">
      <Col span="24">
        <img
          style="width: 100%"
          src="../../../static/img/solutions/smartsite/banner.png"
          alt="#"
        />
      </Col>
      <Col span="24" class="ContactUs_1">
        <div>
          <div class="contactus_font">AI移动巡检安全帽</div>
          <div class="ContactUs_box">
            <div class="ContactUs_box1">
              AI移动巡检安全帽融合了先进的人工智能算法和智能设备功能，专为提升工地安全与管理效率而设计。通过安全隐患识别、质量隐患识别、物料验收识别、人员信息识别，并接入A1知识库及A1+智慧平台，实现全方位的智能巡检。除了核心识别功能外，安全帽还支持实时视频语音通话、群组视频通话、实时视频监控，并配备GPS定位、电子围栏、人员健康监测、有毒有害气体监测等功能。为了保障工地人员安全，安全帽还具备S0S报警、跌落报警、撞击报警、脱帽报警、静默报警、高温报警、近电感应、高度监测等多重安全预警功能，并可实现视频远程指导与可视化管理，为施工现场提供了全面的安全保障和智能化支持:
            </div>
            <div class="ContactUs_box2">
              <div class="box_content" style="margin-left: 20px">
                <div class="box_content_font">300万像素+720P</div>
                <div
                  style="font-weight: 400; font-size: 14px; color: #1a1a1a;SourceHanSansCNRegular"
                >
                  图像清晰、画质细腻不受损
                </div>
              </div>
              <div class="box_content">
                <div class="box_content_font">4G信号传输</div>
                <div
                  style="font-weight: 400; font-size: 14px; color: #1a1a1a;SourceHanSansCNRegular"
                >
                  采用最新的4G技术进行信息传送
                </div>
              </div>
              <div class="box_content">
                <div class="box_content_font">IP65防护等级</div>
                <div
                  style="font-weight: 400; font-size: 14px; color: #1a1a1a;SourceHanSansCNRegular"
                >
                  抗雨淋
                </div>
              </div>
              <div class="box_content" style="margin-left: -68px">
                <div class="box_content_font">重量≤540g</div>
                <div
                  style="font-weight: 400; font-size: 14px; color: #1a1a1a;SourceHanSansCNRegular"
                >
                  满足国家标准的前提下，利用轻量 化设计，将重量做到了最轻
                </div>
              </div>
              <div class="box_content" style="margin-left: 30px">
                <div class="box_content_font">十六大功能一体化</div>
                <div
                  style="font-weight: 400; font-size: 14px; color: #1a1a1a;SourceHanSansCNRegular"
                >
                  利用大数据、云计算、AR、AI等 前沿技术
                </div>
              </div>
              <div class="box_content" style="margin-left: 30px">
                <div class="box_content_font">10h高续航</div>
                <div
                  style="font-weight: 400; font-size: 14px; color: #1a1a1a;SourceHanSansCNRegular"
                >
                  电池用用5000mAh，平均 续航10小时，最长待机可达20小时
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
      <Col span="24" class="ContactUs_2"> </Col>
      <Col span="24" class="ContactUs_3">
        <img
          style="width: 1293px; height: 765px"
          src="../../../static/img/solutions/smartsite/four.png"
          alt=""
        />
      </Col>
      <Col span="24" class="ContactUs_4"></Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.ContactUs_1 {
  height: 520px;
  background-color: #f7f8fa;
  display: flex;
  justify-content: center;
}

.contactus_font {
  margin-top: 3%;
  font-weight: 500;
  font-size: 42px;
  color: #343e51;
  font-family: SourceHanSansCN;
  text-align: center;
}

.ContactUs_box {
  width: 1441px;
  height: 340px;
  background: #ffffff;
  margin-top: 3%;
}

.ContactUs_box1 {
  width: 1440px;
  height: 160px;
  font-family: SourceHanSansCNRegular;
  font-weight: 400;
  font-size: 16px;
  color: #1a1a1a;
  line-height: 32px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  padding: 17px;
  text-indent: 2em;
}

.ContactUs_box2 {
  display: flex;
}

.box_content {
  width: 16.66%;
}

.box_content_font {
  font-family: SourceHanSansCN;
  font-weight: 500;
  font-size: 18px;
  color: #27b9f1;
}

.ContactUs_2 {
  height: 1180px;
  background-image: url("../../../static/img/solutions/smartsite/three.png");
  background-size: 100% 100%;
}

.ContactUs_3 {
  text-align: center;
  margin-top: 66px;
}

.ContactUs_4 {
  height: 950px;
  background-image: url("../../../static/img/solutions/smartsite/five.png");
  background-size: 100% 100%;
}

.LunContent {
  background: #ffffff;
}

.LunContent img {
  width: 100%;
  height: 900px;
}
</style>



// WEBPACK FOOTER //
// src/components/solutions/safetyhelmet.vue